(function($, undefined) {
	'use strict';
    
    let utils;
    let submittingForm = false;

	var changeScheduleDate = function() {
		var btn = $(this);
		var component = btn.closest('.com-program');
		var days = component.find('.com-program__schedule-outer-ctn');
		var activeDay = component.find('.com-program__schedule-outer-ctn:visible');
		var dayToShow;
		var followingDayToShow;
		var schedulesList = $('.js-schedules-list', component);

		if (btn.hasClass('nav-arrow_prev')) {
			dayToShow = activeDay.prev('.com-program__schedule-outer-ctn').length > 0 ? activeDay.prev('.com-program__schedule-outer-ctn') : days.eq(days.length - 1);
		} else {
			dayToShow = activeDay.next('.com-program__schedule-outer-ctn').length > 0 ? activeDay.next('.com-program__schedule-outer-ctn') : days.eq(0);
		}

		followingDayToShow = dayToShow.next('.com-program__schedule-outer-ctn').length > 0 ? dayToShow.next('.com-program__schedule-outer-ctn') : days.eq(0);

		$('.com-program__dates-nav-date_main', component).html(schedulesList.attr('data-'+dayToShow.attr('data-id')));
		$('.com-program__dates-nav-date_next', component).html(schedulesList.attr('data-'+followingDayToShow.attr('data-id')));
		activeDay.fadeOut(function() {
			dayToShow.fadeIn(function() {
				handleHorScrollBtnsDisplay(dayToShow.find('.com-program__schedule-table'));
			});
		});
	};
    
	var jumpScheduleDate = function(day, noAnim) {
        var dayToShow = $('.com-program__schedule-outer-ctn[data-id=' + day + ']');
        var component = dayToShow.closest('.com-program');
		var days = component.find('.com-program__schedule-outer-ctn');
		var activeDay = component.find('.com-program__schedule-outer-ctn:visible');
		var followingDayToShow = dayToShow.next('.com-program__schedule-outer-ctn')[0] ? dayToShow.next('.com-program__schedule-outer-ctn') : days.eq(0);
		var schedulesList = $('.js-schedules-list', component);
        
		$('.com-program__dates-nav-date_main', component).html(schedulesList.attr('data-'+dayToShow.attr('data-id')));
		$('.com-program__dates-nav-date_next', component).html(schedulesList.attr('data-'+followingDayToShow.attr('data-id')));
        
        if (noAnim) {
            activeDay.hide();
            dayToShow.show();
            handleHorScrollBtnsDisplay(dayToShow.find('.com-program__schedule-table'));
        } else {
            activeDay.fadeOut(function() {
                dayToShow.fadeIn(function() {
                    handleHorScrollBtnsDisplay(dayToShow.find('.com-program__schedule-table'));
                });
            });
        }
        utils.scrollToElement(component);
	};

	var handleHorScrollBtnsDisplay = function(schedules = $('.com-program__schedule-table')) {
		schedules.each(function() {
			var table = $(this);
			var parentCtn = table.closest('.com-program__schedule-outer-ctn');
			var scrollBtns = parentCtn.find('.com-program__schedule-scroll-btns');

			if (table.width() > parentCtn.width()) {
				scrollBtns.fadeIn();
			} else {
				scrollBtns.fadeOut();
			}
		});
	};

	var handleHorScrollBtnsPosition = function(schedules = $('.com-program__schedule-table')) {
		// schedules.each(function() {
		// 	var parentCtn = $(this).closest('.com-program__schedule-outer-ctn');
		// 	var scrollBtns = parentCtn.find('.com-program__schedule-scroll-btns');
		// 	var winScroll = $(window).scrollTop();

		// 	if (winScroll >= (parentCtn.offset().top - 250)) {
		// 		scrollBtns.css('top', winScroll - parentCtn.offset().top + 250);
		// 	} else if (winScroll < (parentCtn.offset().top - 250)) {
		// 		scrollBtns.css('top', '2rem');
		// 	}
		// });
	};

	var scrollSchedule = function() {
		var btn = $(this);
		var scheduleToScroll = btn.closest('.com-program__schedule-outer-ctn').find('.com-program__schedule-ctn');

		if (btn.hasClass('nav-arrow_next')) {
			scheduleToScroll.animate({
				scrollLeft: '+=200'
			}, 'slow');
		} else {
			scheduleToScroll.animate({
				scrollLeft: '-=200'
			}, 'slow');
		}
	};
    
    var parseConferenceInfo = function(e) {
        const btn = $(this);
        const popup = $('.stool-shared-popup[data-id=' + btn.attr('data-id'));
        const target = popup.find('.com-program__reserve-info');
        const scheduleCtn = btn.closest('.com-program__schedule-outer-ctn');
        const dayId = scheduleCtn.attr('data-id');
        const day = scheduleCtn.parent().find('.com-program__dates-nav .js-schedules-list').attr('data-' + dayId);
        const item = btn.closest('.com-program__schedule-item');
        const time = item.closest('tr').find('td.com-program__schedule-time').text();
        
        target.html(`<p>${day} - ${time}</p>${item.find('.schedule-item__inner').html()}`);
        let clone = target.clone();
        clone.find('svg').remove();
        $('.com-program__reserve-form', popup).find('[name=conInfo]').val(clone.html());
        $('.com-program__reserve-form', popup).find('[name=conId]').val(item.attr('data-id'));
    };
    
    var submitReserveConference = function(e) {
        e.preventDefault();
        const form = $(this);
        
        $('.js-form-error-message', form).hide();
        Fw.component.models().form.validateForm(form);
        if (!form.hasClass('has-error') && !submittingForm) {
            submittingForm = true;
            $.ajax({
                url: '/action/pmiReserveConference?' + form.serialize(),
                type: 'GET',
                method: 'GET',
                cache: false,
                success: function(response) {
                    submittingForm = false;
                    if (response.indexOf('success-') > -1) {
                        window.location.search = 'reserveId=' + response.trim().replace('success-', '2023');
                    } else {
                        if (response.indexOf('Already reserved') > -1) {
                            $('.js-form-error-message.already-reserved', form).show();
                        } else if (response.indexOf('Full') > -1) {
                            $('.js-form-error-message.maxed-cap', form).show();
                        } else if (response.indexOf('Missing parameter') > -1) {
                            $('.js-form-error-message.fields', form).show();
                        } else {
                            $('.js-form-error-message.error-occured', form).show();
                        }
                    }
                }
            });
        }
    };
	
	var init = function () {
        utils = Fw.component.models().utils;
        
		$('.js-change-program-date').click(changeScheduleDate);
		$('.js-schedule-horizontal-scroll').click(scrollSchedule);

		handleHorScrollBtnsDisplay();
		handleHorScrollBtnsPosition();
		$(window).resize(function() {
			handleHorScrollBtnsDisplay();
		});
		
		$(window).scroll(function() {
			handleHorScrollBtnsPosition();
		});
        
        $('.schedule-item__reserve .btn').click(parseConferenceInfo);
        $('.com-program__reserve-form').on('submit', submitReserveConference);
        
        // Trigger open popup of reservation confirmation
        $('.program-reserve-confirmation-btn').trigger('click');
        
        let queries = utils.getRequestParams();
        // Trigger open schedule on a target day
        if (queries['day']) {
            jumpScheduleDate(queries['day'], true);
        }
        // Trigger open reserve window
        if (queries['conId']) {
            setTimeout(() => {
                let target = $('.com-program__schedule-item[data-id=' + queries['conId'] + '] .schedule-item__reserve .btn').eq(0);
                target.trigger('click');
                openPopup.apply(target[0]);
            }, 400);
        }
	};
	
	$(window).ready(init);
	
})(jQuery);